// import Promise from 'promise-polyfill'; // < 1K min.gz overhead
// if (!window.Promise) window.Promise = Promise;
// import 'core-js/features/symbol/iterator'; // required by IE 11
const promises = [];
// if (!Object.assign) promises.push( import('./old-browser-polyfill') ); // IE11 mostly
promises.push(import(/* webpackChunkName: "all-vendors" */ './vendors'));
// if (!Object.assign) promises.push( import('es6-object-assign/auto') );
// if (!Object.values || !Object.entries) promises.push( import('es7-object-polyfill') );
// if (!Array.prototype.includes) promises.push( import('polyfill-array-includes') );
// if (!Array.prototype.find) promises.push( import('array.prototype.find') );
export default Promise.all(promises);
